export default "__VITE_ASSET__b41e5e27__"